'use strict';

import React, { useState, useEffect } from 'react';

import CollapsibleForm from '../../../components/form/CollapsibleForm';
import UserForms from '../../../definitions/UserForms';
import EagreementCancelModal from './EagreementCancelModal';

import Logger from '../../../utils/Logger';
import { formatShortDate, getTime } from '../../../utils/TimeUtils';

import { isEmpty } from 'lodash';

import { FormattedMessage } from 'react-intl';

import Api from '../../../api/Api';
import SessionUtils from '../../../utils/SessionUtils';

const { id: module_id } = module;
const logger = Logger(module_id);

const UserForm = (props) => {
  const { formValues, userFormId } = props;

  const [form, setForm] = useState({});
  const [values, setValues] = useState({});
  const [status, setStatus] = useState('');

  // used to store original form values for resetting in case of "cancel" - action
  const [origFormValues, setOrigFormValues] = useState({});

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showContent, setShowContent] = useState(true);

  const initializeForm = () => {
    // form is given always on mount and doesn't change, so it's fetched here
    let filteredForm = UserForms.userForms.filter(
      (form) => form.id === userFormId
    )[0];
    setForm(filteredForm);

    setStatus(filteredForm.status);
  };

  useEffect(() => {
    if (isEmpty(form)) {
      initializeForm();
    }

    if (formValues) {
      setValues(formValues);
      setOrigFormValues(formValues); // Store original form values for resetting purpose.
    }
  }, [props.formValues.userAgreement]);

  const toggleShowForm = () => {
    setShowForm(!showForm);
  };

  const toggleContentVisibility = () => {
    setShowContent(!showContent);
  };

  const resetFormValues = () => {
    setValues(origFormValues);
  };

  const toggleConfirmation = () => {
    setConfirmationModal(!confirmationModal);
  };

  const cancel_E_Agreement = () => {
    // User confirmed cancellation by clicking "kyllä"
    Api.updateUserAgreement({
      payload: 'DENIED',
    }).then(() => SessionUtils.logout());
  };

  const formAction = (actionName) => {
    if (actionName === 'open' || actionName === 'close') {
      toggleShowForm();
    } else if (actionName === 'cancel') {
      toggleShowForm();
      resetFormValues();
    } else if (actionName === 'saveUserAgreement') {
      setOrigFormValues(values);
      Api.updateUserAgreement({
        payload: values.userAgreement,
      }).then((json) => {
        toggleShowForm();
      });
    } else if (actionName === 'cancelUserAgreement') {
      // User clicked "peruuta suostumus"
      setConfirmationModal(true); // Open a confirmation modal
    }
  };

  const handleValueChange = (options) => {
    logger.debug('handleValueChange', options);
    setValues({ ...values, ...options });
  };

  return (
    <>
      <>
        {!isEmpty(form) && (
          <CollapsibleForm
            showForm={showForm}
            form={form}
            values={values}
            toggleShowForm={toggleShowForm}
            handleValueChange={handleValueChange}
            showContent={showContent}
            toggleContentVisibility={toggleContentVisibility}
            className={'ot-userform ot-userform__userAgreement row-fluid'}
            header={form.name}
          >
            <div className="row-fluid ot-collapsible-form__bar">
              {status && !showForm && (
                <>
                  <div className="ot-status">
                    <i className="icon-ok" />
                    {status} {formatShortDate(getTime(values.date))}
                  </div>
                  <div className="ot-userAgreementAgreed">
                    {/* If useragreement, show either "agreed" or "agreed, no messages" text */}
                    {status &&
                      form.id === 'userAgreement' &&
                      (values.userAgreement === 'ACCEPTED' ? (
                        <FormattedMessage
                          id={`${module_id}.userAgreementAgreed`}
                          values={{
                            br: <br />,
                            strong: (chunks) => <strong>{chunks}</strong>,
                          }}
                        />
                      ) : (
                        <FormattedMessage
                          id={`${module_id}.userAgreementAgreedNoTextsOrEmails`}
                          values={{
                            br: <br />,
                            strong: (chunks) => <strong>{chunks}</strong>,
                          }}
                        />
                      ))}
                  </div>
                </>
              )}
              {form.buttons[!showForm ? 'closed' : 'open'].map((item, indx) => (
                <div key={indx}>
                  <button
                    className={item.className}
                    onClick={() => formAction(item.action)}
                  >
                    {item.text}
                  </button>
                </div>
              ))}
            </div>
          </CollapsibleForm>
        )}
      </>

      {confirmationModal && (
        <EagreementCancelModal
          isOpen={confirmationModal}
          closeModal={toggleConfirmation}
          cancelAgreement={cancel_E_Agreement}
        />
      )}
    </>
  );
};

export default UserForm;
